import React from "react";
import Sessions from "../sections/home/Sessions";
import ClientStories from "../sections/home/ClientStories";
import MeetYourSpecialist from "../sections/home/MeetYourSpecialist";
import Footer from "../shared/Footer";
import Promotions from "../sections/home/Promotions";
import Hero from "../sections/home/Hero";
import About from "../sections/home/About";
import Spacer from "../shared/Spacer";
import { Link } from "react-router-dom";

const Home = () => {
	return (
		<div>
            <Hero />
            {/* Add spacing to push content down so it can scroll over the hero */}
            <div style={{ height: '95vh' }}></div>
            <div className="position-relative" style={{ backgroundColor: 'white', zIndex: 1 }}>
                <Spacer />
                <div className="my-5" id="about-luna-pearl">
                    <About />
                </div>
                <div id="sessions">
                    <Spacer />
                    <Sessions />
                </div>
                <div id="promotions">
                    <Spacer />
                    <Promotions />
                </div>
                <div id="client-stories">
                    <Spacer />
                    <ClientStories />
                </div>
                <div id="meet-your-specialist">
                    <Spacer />
                    <MeetYourSpecialist />
                </div>
                <Spacer />
                <div className="d-flex justify-content-center">
                    <Link to="/contact-us" className="btn btn-dark btn-lg p-3">Contact Us</Link>
                </div>
                <Spacer />
                <Footer />
            </div>
		</div>
	);
};

export default Home;
